module.exports = __webpack_public_path__ + "img/AUTO_TRANSPORTS_OUI.0077af5a.svg";